module.exports = __webpack_public_path__ + "static/img/33.81d0d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/33.png
// module id = uuxI
// module chunks = 0